import type { ResourcesConfig } from "aws-amplify";
import { I18n } from "aws-amplify/utils";

I18n.setLanguage("en");
I18n.putVocabularies({
  en: {
    "username is required to resetPassword":
      "Email is required to reset your password",
    "username is required to signIn": "Email is required to sign in",
    "Username/client id combination not found.": "Email not found",
    "PreAuthentication failed with error Access Denied: Google login is not allowed for this account":
      "Access Denied: Google login is not allowed for this account.",
  },
});

const exports = (
  userPoolId: string,
  userPoolClientId: string,
  domain: string,
): ResourcesConfig => ({
  Auth: {
    Cognito: {
      userPoolId,
      userPoolClientId,
      loginWith: {
        oauth: {
          domain,
          scopes: ["email", "openid", "profile"],
          redirectSignIn: [window.location.origin],
          redirectSignOut: [window.location.origin],
          responseType: "code",
          // microsoft doesn't use mfa instead uses a cognito custom auth with msal
          providers: ["Google"],
        },
      },
    },
  },
});

export default exports;
